import React from "react";

import { Card, styled, Typography } from "@mui/material";
import { OrderProductType } from "../../../Core/Api/Types/order-product-type";
import OrderProductIcon from "../../Misc/OrderProductIcon/order-product-icon";
export type ProductConfigCardProps = {
  className?: string;
  id: number;
  title: string;
  type: OrderProductType;
  selected: boolean;
  onClickCard: (productId: number) => void;
  disabled?: boolean;
};

const ProductConfigCard: React.FC<ProductConfigCardProps> = (props) => {
  const handleOnClick = () => {
    if (props.disabled) {
      return;
    }
    props.onClickCard(props.id);
  };

  return (
    <StyledCard variant="outlined" onClick={handleOnClick} aria-selected={props.selected} disabled={props.disabled}>
      <OrderProductIcon color="inherit" type={props.type} />

      <Typography variant="body1" component="span" fontWeight={500}>
        {props.title}
      </Typography>
    </StyledCard>
  );
};

const StyledCard = styled(Card, {
  shouldForwardProp: (prop) => prop !== "disabled",
})<{ disabled: ProductConfigCardProps["disabled"] }>(({ theme, disabled }) => ({
  display: "flex",
  alignItems: "center",
  flexDirection: "column",
  justifyContent: "center",
  width: "100%",
  height: "100%",
  padding: `${theme.spacing(1.5)} ${theme.spacing(2.5)}`,
  borderRadius: 6,
  background: disabled ? "transparent" : theme.palette.backgroundAlpha.main,
  transition: "all .3s",
  cursor: disabled ? "not-allowed" : "pointer",
  color: disabled ? theme.palette.text.disabled : theme.palette.text.primary,
  textAlign: "center",

  ...(!disabled && {
    "&:hover": {
      background: theme.palette.backgroundAlpha.hover,
    },
  }),

  span: {
    display: "block",
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    maxWidth: 145,
    margin: "auto",
  },
  svg: {
    width: 40,
    height: 40,
    color: disabled ? theme.palette.text.disabled : theme.palette.text.tier,
    transition: "color .3s",
    marginBottom: theme.spacing(0.5),
  },

  "&[aria-selected=true]": {
    color: theme.palette.primary.text,
    svg: {
      color: theme.palette.primary.main,
    },
    "&:hover": {
      svg: {
        color: theme.palette.primary.main,
      },
    },
  },
}));

export default ProductConfigCard;
